import React from "react";
import data from "../../json/landingpage/services.json";
import { Link } from "react-router-dom";

const Servicesnew = () => {
  return (
    <div className="2xl:container w-full px-6 sm:px-10 md:px-10 lg:px-20  py-14 sm:py-20 ">
      <div className="flex w-full flex-col items-center gap-3 sm:gap-4">
        <p className="font-miniheading text-orangeyellow text-16 font-semibold lg:text-20">
          WHAT WE DO
        </p>
        <h2 className="text-primarycolor font-semibold lg:text-48 text-center w-full xl:w-[80%]  text-20 min-[450px]:text-24 md:text-36">
          Streamlining publishing with{" "}
          <span className="text-ctaorange">expert services</span> and smart
          technology
        </h2>
        <p className="text-16 md:text-18  text-center w-full xl:w-[72%] w-[90%]  text-regular text-secondaryblack">
          We provide end-to-end services like content transformation, digital
          services, editing, production, accessibility, and data analytics
          leveraging AI, NLP, and automation for accuracy and efficiency.
        </p>
      </div>
      {/* <div className="flex flex-col md:flex-row w-full justify-between"> */}
      <div className="grid grid-cols-1 lg:grid-cols-3 w-full gap-8  xl:gap-10  pt-12 md:pt-16 lg:pt-20 service-cards  lg:mt-10">
        {data.services.map((el, i) => (
          <Link
            key={i}
            to={el.linkto}
            className="md:transform md:hover:scale-105 transition-transform duration-300 mt-10 lg:mt-0  mx-auto service-card-link  max-lg:w-full"
          >
            {/* <div className="relative flex flex-col md:h-auto md:min-h-[410px] md:max-w-[450px] md:w-[30.306vw] items-center gap-3 justify-center"> */}
            <div className="w-full h-full ">
              <div className="half-circle shadow-services"></div>
              <div className="w-full service-card flex justify-center ">
                <img
                  className="lg:w-[100px] lg:h-[100px] w-[70px] h-[70px] object-cover"
                  src={process.env.PUBLIC_URL + el.bgimg}
                  alt={el.alt}
                ></img>
              </div>
              <div className="px-6 md:px-4 xl:px-6 py-6 pt-20 lg:pt-24 flex flex-col gap-4 items-center text-center border-[2px] border-journyborder shadow-services rounded-[24px] h-full">
                <h2 className="text-20 min-[450px]:text-24  text-primarycolor font-semibold">{el.title}</h2>
                <p className="lg:min-h-[90px] text-16 font-regular text-secondaryblack md:w-[70%] lg:w-full">{el.desc}</p>
                <div className="flex justify-center gap-4 items-center">
                  <p className="text-ctaorange text-16 font-semibold">
                    Enquire Now
                  </p>
                  <img
                    className="w-auto h-auto"
                    src={
                      process.env.PUBLIC_URL +
                      "/images/Herosection/greaterthan.svg"
                    }
                    alt="next_arrow"
                  />
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Servicesnew;
